import React from 'react';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { useRestrictToLoggedIn } from '../../../utils/hooks/useRestrictToLoggedIn';
import ActionBarStrip from '../../_partials/ActionBarStrip';
import FavouriteButton from '../../buttons/FavouriteButtonWithPopover';
import CommentButton from '../../buttons/CommentButton';
import ShareButton from '../../buttons/ShareButton';
import AddToGroupButton from '../../buttons/AddToGroupButton/AddToGroupButtonWithPopover';
import MoreButton from '../../buttons/MoreButton';
import DeleteButton from '../../buttons/DeleteButton';
import EditButton from '../../buttons/EditButton';
import AwardBadgeButton from '../../buttons/AwardBadgeButton';
import { useDeviationAttributes } from '../../../DeviationViews/hooks/useDeviationAttributes';
import { getDeviationType } from '../../../DeviationViews/_helpers';
import { DeviationTypes } from '../../../types/deviation';
import AdoptableSeller from '../../buttons/AdoptableSeller';
import AddToPrivateCollectionButton from '../../buttons/AddToPrivateCollectionButtonWithPopover';
import AdoptableBuyer from '../../buttons/AdoptableBuyer';
import OrderCommissionButton from '../../buttons/OrderCommissionButton';
import FreeDownloadButton from '../../buttons/DownloadButton/FreeDownloadButton';
import PremiumDownloadButton from '../../buttons/DownloadButton/PremiumDownloadButton';
import LoginToDownloadButton from '../../buttons/DownloadButton/LoginToDownloadButton';
import SellYourArtLink from '../../buttons/SellYourArtLink';
import s from './MobileActionBar.scss';
export const MobileActionBar = ({ deviation , isOwner  })=>{
    var _deviation_adoptable, _deviation_extended, _deviation_extended1, _deviation_extended_adoptable;
    const { isLoggedIn  } = useRestrictToLoggedIn();
    const { hasMoreActions , isCommentable , isEditable , isFavouritable , isGroupSubmittable , isShareable , isDeletable , isCoreBadgeAwardable , isAuthorCommissionable , isDownloadable , isPurchasable  } = useDeviationAttributes(deviation, isOwner);
    const { commission  } = deviation;
    const isPrivateCollections = useFlag('private_collections');
    const isAnAdoptable = deviation.isAdoptable;
    // tiers are technically editable but, for now, the tier edit popup doesn't work on mobile
    const canBeEdited = getDeviationType(deviation) === DeviationTypes.TIER ? false : isEditable;
    var _deviation_adoptable_status;
    const adoptableStatus = (_deviation_adoptable_status = (_deviation_adoptable = deviation.adoptable) === null || _deviation_adoptable === void 0 ? void 0 : _deviation_adoptable.status) !== null && _deviation_adoptable_status !== void 0 ? _deviation_adoptable_status : 'not_onsale';
    const showSellYourArt = !!(((_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.canUserSell) && adoptableStatus === 'not_onsale');
    const canBuyAdoptable = ((_deviation_extended1 = deviation.extended) === null || _deviation_extended1 === void 0 ? void 0 : (_deviation_extended_adoptable = _deviation_extended1.adoptable) === null || _deviation_extended_adoptable === void 0 ? void 0 : _deviation_extended_adoptable.canAdopt) && !isOwner;
    return /*#__PURE__*/ React.createElement(ActionBarStrip, {
        className: s['root']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['icons-wrapper']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['left-block']
    }, isFavouritable && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(FavouriteButton, {
        deviation: deviation,
        actionBarType: "primary"
    })), isCommentable && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(CommentButton, {
        deviation: deviation,
        isOwner: isOwner
    })), isOwner && !hasMoreActions && isGroupSubmittable && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(AddToGroupButton, {
        deviation: deviation
    })), isShareable && !hasMoreActions && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(ShareButton, {
        deviation: deviation
    }))), /*#__PURE__*/ React.createElement("div", {
        className: s['right-block']
    }, commission && !isOwner && isAuthorCommissionable && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(OrderCommissionButton, {
        deviation: deviation
    })), isPrivateCollections && !isOwner && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(AddToPrivateCollectionButton, {
        deviation: deviation
    })), isGroupSubmittable && hasMoreActions && isOwner && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(AddToGroupButton, {
        deviation: deviation
    })), isCoreBadgeAwardable && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(AwardBadgeButton, {
        deviation: deviation
    })), isDownloadable && isLoggedIn && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(FreeDownloadButton, {
        deviation: deviation
    })), hasMoreActions && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(MoreButton, {
        deviation: deviation
    })), isDeletable && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(DeleteButton, {
        deviation: deviation
    })), canBeEdited && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(EditButton, {
        deviation: deviation
    })))), /*#__PURE__*/ React.createElement("div", {
        className: s['download-button-row']
    }, showSellYourArt && /*#__PURE__*/ React.createElement(SellYourArtLink, {
        deviation: deviation
    }), isPurchasable && isLoggedIn && !isAnAdoptable && /*#__PURE__*/ React.createElement(PremiumDownloadButton, {
        deviation: deviation
    }), (isPurchasable || isDownloadable) && !isAnAdoptable && !isLoggedIn && /*#__PURE__*/ React.createElement(LoginToDownloadButton, {
        className: s['full-width'],
        deviation: deviation
    }), isAnAdoptable && isOwner && /*#__PURE__*/ React.createElement(AdoptableSeller, {
        deviation: deviation
    }), canBuyAdoptable && /*#__PURE__*/ React.createElement(AdoptableBuyer, {
        deviation: deviation
    })));
};
MobileActionBar.displayName = 'MobileActionBar';
export default MobileActionBar;
